import { Grid, Icon, LinearProgress, makeStyles, Tooltip } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import { OnboardingContext } from 'app/main/onboarding/OnboardingContext';
import { excluirAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import * as MessageActions from 'app/store/actions/fuse/message.actions';
import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext, useEffect, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { useDispatch } from 'react-redux';
import UploadImageCrop from './UploadImageCrop';

const useStyles = makeStyles((theme) => ({
  container: {
    textAlign: 'center',
    height: '250px',
    backgroundColor: '#f5f5f5',
  },
  icon: {
    fontSize: '7.6rem',
    color: '#2e62b8',
    marginTop: '5%',
  },
  content: {
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'left',
    color: '#464646',
  },
  formatosPermitidos: {
    fontSize: '12px',
    lineHeight: 1.29,
    color: '#65666f',
  },
  imagem: {
    marginTop: '3%',
    marginBottom: '1%',
    width: '80px',
    height: '80px',
  },
  MuiLinearProgressRoot: {
    height: '8px',
    borderRadius: '8px',
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#2e62b8',
    },
  },
  check: {
    color: '#27ae60',
    fontSize: '16px',
    marginLeft: '6px',
  },
}));

const UploadImage = () => {
  const classes = useStyles(useStyles);

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [, setFileSize] = useState();
  const [uploadConcluido, setUploadConcluido] = useState(false);
  const [empresa] = useContext(GlobalContext).empresa;
  const [uploading, setUploading] = useContext(OnboardingContext).uploading;
  const [, setLoading] = useContext(OnboardingContext).loading;

  const [modal, setModal] = useState('');
  const [imgCrop, setImgCrop] = useState(null);
  const [imgOriginal, setImgOriginal] = useState(null);

  const dispatch = useDispatch();

  const showError = (message) => {
    dispatch(MessageActions.showMessage({ message, variant: 'error' }));
  };

  const showSucess = (message) => {
    dispatch(MessageActions.showMessage({ message, variant: 'success' }));
  };

  useEffect(() => {
    async function carrega() {
      if (empresa.logomarcaId) {
        setLoading(true);
        let logomarca = await empresaApi.buscarLogoMarca(empresa.logomarcaId);
        setFileName(logomarca.data.name);
        setFileSize(logomarca.data.tamanho);
        setUploadConcluido(true);
        setFile('data:' + logomarca.data.contentType + ';base64,' + logomarca.data.content);
        setLoading(false);
      }
    }

    carrega();
  }, [empresa.logomarcaId, setLoading]);

  const handleChange = (arquivo) => {
    setUploading(true);

    if (!arquivo) {
      setUploading(false);
      return;
    }

    if (arquivo.size > 200000) {
      showError('É permitido anexar apenas 1 imagem de no máximo 200KB');
      setUploading(false);
      return;
    }

    const lastDot = arquivo.name.lastIndexOf('.');
    const ext = arquivo.name.substring(lastDot + 1).toLowerCase();

    if (ext !== 'jpg' && ext !== 'jpeg' && ext !== 'png') {
      showError('É permitido anexar somente imagem nos formatos: JPEG, JPG e PNG');
      setUploading(false);
      return;
    }

    const reader = new FileReader();
    reader.addEventListener('load', () => setImgCrop(reader.result));
    reader.readAsDataURL(arquivo);

    setModal('recortarLogo');

    setImgOriginal(arquivo);
    setImgCrop(arquivo);

    setFile(arquivo);
    setFileName(arquivo.name);
    setFileSize(arquivo.size);

    setUploading(false);
    setUploadConcluido(true);
  };

  const handleExcluirLogomarca = () => {
    excluirAlert({
      confirmar: async () => {
        await empresaApi.excluirLogoMarca(empresa.logomarcaId);
        empresa.logomarca = undefined;
        empresa.logomarcaId = undefined;
        setFile(null);
        showSucess('Logomarca excluída com sucesso.');
      },
      opcoes: {
        title: 'Você realmente deseja excluir?',
        text: '',
      },
    });
  };

  const exibeAreaPreUpload = () => {
    return (
      <Tooltip title={'Adicionar imagem'} placement="bottom">
        <span>
          <FileUploader
            multiple={false}
            className="hidden"
            handleChange={handleChange}
            name="file"
            label=""
            hoverTitle=" "
          >
            <label
              htmlFor="button-file"
              className={
                'flex items-center justify-center relative rounded-4 mx-8 mb-16 overflow-hidden cursor-pointer shadow-1 hover:shadow-5'
              }
            >
              <Grid container className={classes.container}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Icon className={classes.icon} color="action">
                    cloud_upload
                  </Icon>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <span className={classes.content}>Arraste o arquivo ou clique para adicioná-lo.</span>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginBottom: '5%' }}>
                  <span className={classes.formatosPermitidos}>Formatos permitidos: JPEG, JPG e PNG.</span>
                </Grid>
              </Grid>
            </label>
          </FileUploader>
        </span>
      </Tooltip>
    );
  };

  const exbibeAreaPosUpload = () => {
    return (
      <label
        htmlFor="button-file"
        className={
          'flex items-center justify-center relative rounded-4 mx-8 mb-16 overflow-hidden cursor-pointer shadow-1 hover:shadow-5'
        }
      >
        <Grid container className={classes.container}>
          <UploadImageCrop
            modal={modal}
            imgCrop={imgCrop}
            setUpImg={setFile}
            closeModal={setModal}
            imgOriginal={imgOriginal}
          />

          <Grid item lg={12} md={12} sm={12} xs={12}>
            {typeof file === 'string' ? (
              <center>
                <div className={classes.imagem}>
                  <img src={file} alt="Thumb" />
                </div>
              </center>
            ) : (
              <center>
                <div className={classes.imagem}>
                  <img src={imgCrop} alt="Thumb" />
                </div>
              </center>
            )}
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2} />
          <Grid item lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'left' }}>
            <span className={classes.content}>{fileName}</span>
            <CheckCircle className={classes.check} />
          </Grid>
          <Grid item lg={1} md={1} sm={1} xs={1} style={{ textAlign: 'left' }}></Grid>
          <Grid item lg={1} md={1} sm={1} xs={1} style={{ textAlign: 'right' }}>
            <button title="Excluir imagem adicionada" onClick={handleExcluirLogomarca}>
              x
            </button>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2} />
          <Grid item lg={2} md={2} sm={2} xs={2} />
          <Grid item lg={8} md={8} sm={8} xs={8}>
            {uploading ? (
              <LinearProgress className={classes.MuiLinearProgressRoot} />
            ) : uploadConcluido ? (
              <LinearProgress className={classes.MuiLinearProgressRoot} variant="determinate" value={100} />
            ) : null}
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2} />
          <Grid item lg={8} md={8} sm={8} xs={8} />
          <Grid item lg={2} md={2} sm={2} xs={2} style={{ textAlign: 'right', fontSize: '10px', marginBottom: '5%' }}>
            {uploadConcluido ? <label style={{ fontSize: '14px' }}>100%</label> : null}
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2} />
        </Grid>
      </label>
    );
  };

  return <>{!file ? exibeAreaPreUpload() : exbibeAreaPosUpload()}</>;
};

export default UploadImage;
